import { render, staticRenderFns } from "./PropertySales.vue?vue&type=template&id=a11ad0c4&"
import script from "./PropertySales.vue?vue&type=script&lang=js&"
export * from "./PropertySales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports